import { render, staticRenderFns } from "./MyRecipe_Modal.vue?vue&type=template&id=f5ff1f3c&scoped=true&"
import script from "./MyRecipe_Modal.vue?vue&type=script&lang=js&"
export * from "./MyRecipe_Modal.vue?vue&type=script&lang=js&"
import style0 from "./MyRecipe_Modal.vue?vue&type=style&index=0&id=f5ff1f3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ff1f3c",
  null
  
)

export default component.exports